import React from 'react';

interface Props {
  open: boolean;
  onAccept: () => void;
  onDecline: () => void;
}

const CompanionConsentModal: React.FC<Props> = ({ open, onAccept, onDecline }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" aria-hidden="true" />

      {/* Dialog */}
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="consent-title"
        className="relative z-10 w-full max-w-2xl max-h-[90vh] flex flex-col rounded-2xl border border-gray-200 dark:border-white/10 bg-white dark:bg-stone-900 shadow-xl overflow-hidden"
      >
        {/* Header */}
        <div className="flex-none px-6 pt-6 pb-4 border-b border-gray-100 dark:border-white/10" style={{ backgroundColor: '#063932' }}>
          <p className="text-xs font-semibold uppercase tracking-widest text-white/60 mb-1">
            Pop-up Consent Notice
          </p>
          <h2 id="consent-title" className="text-lg font-bold text-white">
            Disclaimer and Limitation of Use
          </h2>
        </div>

        {/* Scrollable body */}
        <div className="flex-1 overflow-y-auto px-6 py-5 space-y-5 text-sm text-slate-700 dark:text-slate-300 leading-relaxed">
          <p>
            Click Law is a legal technology platform designed to facilitate access to legal
            information, tools, and data for general informational purposes only. By accessing and
            using Click Law, you acknowledge and agree that Click Law does not provide legal,
            financial, tax, accounting, or any other form of professional advice.
          </p>
          <p>
            All content, data, documents and functionalities made available through Click Law are
            provided on an{' '}
            <span className="font-semibold">&ldquo;as is&rdquo;</span> basis and are intended to
            support, not replace, independent professional judgment. Nothing on the Click Law
            platform should be construed as creating a lawyer–client relationship, fiduciary
            relationship, or any other professional relationship between you and Click Law or its
            operators or proprietors.
          </p>
          <p>
            Any decisions, actions, or omissions taken by you in reliance on Click Law, including
            reliance on any data, documents, analyses, or interpretations generated or accessed
            through the platform, are undertaken at your own discretion and risk. You retain full
            responsibility for verifying the accuracy, completeness, suitability and legal effect of
            any information obtained through Click Law, and for obtaining appropriate professional
            advice where required.
          </p>
          <p>
            Click Law shall not be liable for any loss, damage, claim, or liability (whether direct,
            indirect, incidental, consequential, or otherwise) arising from or in connection with
            your use of, or reliance on, the Click Law platform or any information contained therein.
          </p>
          <p className="font-medium text-slate-800 dark:text-slate-200">
            By continuing to use Click Law, you confirm that you understand and accept the
            limitations of the platform and agree to use it in a lawful, responsible, and informed
            manner.
          </p>

        </div>

        {/* Footer actions */}
        <div className="flex-none px-6 py-4 border-t border-gray-100 dark:border-white/10 flex flex-col sm:flex-row gap-3 justify-end bg-slate-50 dark:bg-stone-800/60">
          <button
            type="button"
            onClick={onDecline}
            className="w-full sm:w-auto px-6 py-2.5 rounded-lg border border-gray-300 dark:border-white/10 text-sm font-medium text-slate-700 dark:text-slate-300 hover:bg-gray-100 dark:hover:bg-white/5 transition-colors"
          >
            I Do Not Agree
          </button>
          <button
            type="button"
            onClick={onAccept}
            className="w-full sm:w-auto px-6 py-2.5 rounded-lg text-sm font-semibold text-white transition-opacity hover:opacity-90"
            style={{ backgroundColor: '#063932' }}
          >
            I Agree &amp; Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompanionConsentModal;
